import { config } from 'dotenv';
import { drizzle } from 'drizzle-orm/postgres-js';
import postgres from 'postgres';

import * as schema from './schema';

const env = process.env.NODE_ENV || 'development';
config({ path: `.env.${env}` });

const client = postgres(process.env.DATABASE_URL!);
export const db = drizzle(client, { schema });
